var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64844 20.678H4.62612L4.6039 20.68C4.38779 20.6993 4.05662 20.6521 3.79403 20.4646C3.55926 20.2969 3.31641 19.9734 3.31641 19.2969V6.9375H4.14844V19.2969V19.7969H4.64844H17.0407V20.678H4.64844Z",
    stroke: "#C7CEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52441 2.81641C7.41984 2.81641 6.52441 3.71184 6.52441 4.81641V15.4141C6.52441 16.5186 7.41984 17.4141 8.52441 17.4141H19.1836C20.2882 17.4141 21.1836 16.5186 21.1836 15.4141V4.81641C21.1836 3.71184 20.2882 2.81641 19.1836 2.81641H8.52441ZM16.6678 8.81553H14.2868V6.43452L16.6678 8.81553ZM14.7197 5.78516H11.2564C10.7759 5.78516 10.3906 6.17045 10.3906 6.65098V13.5775C10.3906 13.8072 10.4818 14.0274 10.6442 14.1898C10.8066 14.3521 11.0268 14.4434 11.2564 14.4434H16.4514C16.681 14.4434 16.9012 14.3521 17.0636 14.1898C17.226 14.0274 17.3172 13.8072 17.3172 13.5775V8.38262L14.7197 5.78516ZM15.1526 11.8459V12.7117H11.2564V11.8459H15.1526ZM16.4514 10.1143V10.9801H11.2564V10.1143H16.4514Z",
    fill: "#C7CEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.7b751d3e386cf85b22dcbac7032d9ab4.svg";
export { ForwardRef as ReactComponent };